import moment, {Moment} from 'moment'
import {TFunction} from 'i18next'

// "today 14:56", "yesterday 18:20" or a plain date; null for an unreadable date.
export const formatRelativeDate = (date: Moment, t: TFunction, withTime = false): string | null => {
	if (!date.isValid()) return null
	const time = withTime ? ` ${date.format('HH:mm')}` : ''
	if (date.isSame(moment(), 'day')) return `${t('dashboardPage.today')}${time}`
	if (date.isSame(moment().subtract(1, 'day'), 'day')) return `${t('dashboardPage.yesterday')}${time}`
	return date.format(withTime ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY')
}
